import React from 'react'
import ReactDOM from 'react-dom/client'
import DAMKSPCSystem from './components/DAMKSPCSystem'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <DAMKSPCSystem />
  </React.StrictMode>,
)
